export function Prototype (pConfig)
{
  return (
  {
    toolbarSizeHeight : 80,
    singlePaddingTop: 7+3,

    btnFileName: 'iconsSmall',

    btnIcoUpNormal : 0,
    btnIcoUpOver : 1,
    btnIcoUpDisable : 3,
    btnIcoDownNormal : 2,
    btnIcoDownOver : 4,
    btnIcoDownDisable : 5,

    btnOverlapping: 1,

    sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
    sepSizeWidth : 10,
    sepSizeHeight : 28,
    sepSizeVertical: 4,

    Groups :
    [
      {
        name : 'HistoryActions',

        Buttons :
        [
          {
            name : 'Undo',
            title : 'Undo',
            command : 'undo'
          },

          {
            name : 'Redo',
            title : 'Redo',
            command : 'redo'
          }
        ]
      },

      {
        name : 'HistoryActionsMini',

        Buttons :
        [
          {
            name : 'Undo',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Redo',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'HistoryActionsPublic',

        Buttons :
        [
          {
            name : 'Undo',
            title : 'Undo',
            command : 'undo'
          },

          {
            name : 'Redo',
            title : 'Redo',
            command : 'redo'
          }
        ]
      },

      {
        name : 'TextActions',

        Buttons :
        [
          {
            name : 'CopyStyle',
            title : 'Format painter',
            command : 'copyStyle'
          },

          {
            name : 'ClearFormatting',
            title : 'Clear formatting',
            command : 'cleanupHTML'
          }
        ]
      },

      {
        name : 'TextActionsMini',
        sepSizeWidth : 25,

        Buttons :
        [
          {
            name : 'CopyStyle',
            type : 'LinkToExistingButton'
          },

          {
            name : 'ClearFormatting',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'TextActionsMiniPoll',
        sepSizeWidth : 14,

        Buttons :
        [
          {
            name : 'CopyStyle',
            type : 'LinkToExistingButton'
          },

          {
            name : 'ClearFormatting',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'CopyPaste',

        Buttons :
        [
          {
            name : 'Copy',
            title : 'Copy',
            command : 'copy'
          },

          {
            name : 'Paste',
            title : 'Paste',
            command : 'paste'
          }
        ]
      },

      {
        name : 'CopyPasteMini',
        sepSizeWidth : 24,

        Buttons :
        [
          {
            name : 'Copy',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Paste',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'TextDecoration',

        Buttons :
        [
          {
            name : 'Bold',
            title : 'Bold',
            command : 'bold'
          },

          {
            name : 'Italic',
            title : 'Italic',
            command : 'italic'
          },

          {
            name : 'Underline',
            title : 'Underline',
            command : 'underline'
          },

          {
            iconName: 'MoreDropdown',
            name : 'MoreTextDecoration',
            type : 'MoreButtonsDropdown',
            title : 'More...',
            command : 'openMoreTextDecoration'
          }
        ]
      },

      {
        name : 'TextDecorationDropdown',
        dropdownGroup : true,
        dropdownGroupType : 'MoreButtonsDropdown',
        openerButtonName : 'MoreTextDecoration',
        sepSizeWidth : 0,
        parameters :
        {
          directURL: '/Common/Editor/buttons/ButtonsDropdown.aspx?' + BEditor.environment.version,
          isTransparent : true
        },

        Buttons :
        [
          {
            name : 'Superscript',
            title : 'Superscript',
            command : 'superscript',
            isStackable : false
          },

          {
            name : 'Subscript',
            title : 'Subscript',
            command : 'subscript',
            isStackable : false
          },

          {
            name : 'Strikethrough',
            title : 'Strikethrough',
            command : 'strikethrough',
            isStackable : false
          }
        ]
      },

      {
        name : 'TextDecorationPublic',

        Buttons :
        [
          {
            name : 'Bold',
            title : 'Bold',
            command : 'bold'
          },

          {
            name : 'Italic',
            title : 'Italic',
            command : 'italic'
          },

          {
            name : 'Underline',
            title : 'Underline',
            command : 'underline'
          },

          {
            iconName: 'MoreDropdown',
            name : 'MoreTextDecorationPublic',
            type : 'MoreButtonsDropdown',
            title : 'More...',
            command : 'openMoreTextDecorationPublic'
          }
        ]
      },

      {
        name : 'TextDecorationCardsPublic',

        Buttons :
        [
          {
            name : 'Bold',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Italic',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Underline',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'TextDecorationDropdownPublic',
        dropdownGroup : true,
        dropdownGroupType : 'MoreButtonsDropdown',
        openerButtonName : 'MoreTextDecorationPublic',
        sepSizeWidth : 0,
        parameters :
        {
          directURL: '/Common/Editor/buttons/ButtonsDropdown.aspx?' + BEditor.environment.version,
          isTransparent : true
        },

        Buttons :
        [
          {
            name : 'Superscript',
            title : 'Superscript',
            command : 'superscript',
            isStackable : false
          },

          {
            name : 'Subscript',
            title : 'Subscript',
            command : 'subscript',
            isStackable : false
          },

          {
            name : 'Strikethrough',
            title : 'Strikethrough',
            command : 'strikethrough',
            isStackable : false
          }
        ]
      },

      {
        name : 'BlockStyles',

        Buttons :
        [
          {
            name : 'FormattingDropdown',
            type : 'DropdownButton',
            title: 'Styles',
            command : 'openBlockFormattingDropdown',
            parameters :
            {
              directURL: '/Content/Editor/StylesDropdown.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              styles : pConfig.themeStyles.formatStyles,

              defaultStyleId : 'Normal',
              offsetY: -1,
              isTransparent : true,

              callBackParameters :
              {
                selectedStyleId : 'P'
              }
            }
          },

          {
            name : 'TextFont',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Text font',
            command : 'openTextFontDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              textFonts : pConfig.themeStyles.fontStyles,

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'FontSize',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Font size',
            command : 'openFontSizeDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              fontSizes :
              [
                '8',
                '9',
                '10',
                '11',
                '12',
                '14',
                '16',
                '18',
                '24',
                '30',
                '36',
                '48',
                '60',
                '72'
              ],

              fontSizeIds :
              [
                '8',
                '9',
                '10',
                '11',
                '12',
                '14',
                '16',
                '18',
                '24',
                '30',
                '36',
                '48',
                '60',
                '72'
              ],

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'LineHeight',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Line height',
            command : 'openLineHeightDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              lineHeights :
              [
                {
                  'id': '0.90',
                  'label': '0.90'
                },
                {
                  'id': '1.00',
                  'label': '1.00'
                },
                {
                  'id': '1.15',
                  'label': '1.15'
                },
                {
                  'id': '1.40',
                  'label': '1.40'
                },
                {
                  'id': '1.50',
                  'label': '1.50'
                },
                {
                  'id': '1.70',
                  'label': '1.70'
                },
                {
                  'id': '2.00',
                  'label': '2.00'
                },
                {
                  'id': 'auto',
                  'label': 'Auto',
                  'separator': true
                },
                {
                  'id': 'SpaceBeforeBlock',
                  'label': 'space before paragraph'
                },
                {
                  'id': 'SpaceAfterBlock',
                  'label': 'space after paragraph'
                }
              ],

              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },
//========================================================================================================
      {
        name : 'BlockStylesMini',

        Buttons :
        [
          {
            name : 'FormattingDropdownMini',
            type : 'DropdownButton',
            title: 'Styles',
            command : 'openBlockFormattingDropdown',
            parameters :
            {
              directURL: '/Content/Editor/StylesDropdown.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              styles : pConfig.themeStyles.formatStyles,

              defaultStyleId : 'Normal',
              offsetY: -1,
              isTransparent : true,

              callBackParameters :
              {
                selectedStyleId : 'P'
              }
            }
          },

          {
            name : 'TextFontMini',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Text font',
            command : 'openTextFontDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              textFonts : pConfig.themeStyles.fontStyles,

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'FontSize',
            type : 'LinkToExistingButton'
          },

          {
            name : 'LineHeight',
            type : 'LinkToExistingButton'
          }
        ]
      },
//========================================================================================================
      {
        name : 'BlockStylesEmail',

        Buttons :
        [
          {
            name : 'FormattingDropdownEmail',
            iconName: 'FormattingDropdown',
            type : 'DropdownButton',
            title: 'Styles',
            command : 'openBlockFormattingDropdown',
            parameters :
            {
              directURL: '/Content/Editor/StylesDropdown.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              styles :
              [
                {
                  name: 'Normal',
                  tag: 'P',
                  cssClass: ''
                },
                {
                  name: 'Heading1',
                  tag: 'H1',
                  cssClass: ''
                },
                {
                  name: 'Heading2',
                  tag: 'H2',
                  cssClass: ''
                },
                {
                  name: 'Heading3',
                  tag: 'H3',
                  cssClass: ''
                },
                {
                  name: 'Heading4',
                  tag: 'H4',
                  cssClass: ''
                },
                {
                  name: 'Caption',
                  tag: 'P',
                  cssClass: 'waCaption',
                  isOptional: true
                },
                {
                  name: 'Quoted text',
                  tag: 'P',
                  cssClass: 'waQuotedText',
                  isOptional: true
                },
                {
                  name: 'Smaller text',
                  tag: 'P',
                  cssClass: 'waSmallerText',
                  isOptional: true
                }
              ],

              defaultStyleId : 'Normal',
              offsetY: -1,
              isTransparent : true,

              callBackParameters :
              {
                selectedStyleId : 'P'
              }
            }
          },

          {
            name : 'TextFontEmail',
            iconName: 'TextFont',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Text font',
            command : 'openTextFontDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              textFonts :
              [
                {
                  font: 'Arial, Helvetica, sans-serif',
                  name: 'Arial'
                },
                {
                  font: 'Comic Sans MS',
                  name: 'Comic&nbsp;Sans&nbsp;MS'
                },
                {
                  font: 'Courier',
                  name: 'Courier'
                },
                {
                  font: 'Georgia',
                  name: 'Georgia'
                },
                {
                  font: 'Impact',
                  name: 'Impact'
                },
                {
                  font: 'Helvetica',
                  name: 'Helvetica'
                },
                {
                  font: 'Lucida Console',
                  name: 'Lucida&nbsp;Console'
                },
                {
                  font: 'Tahoma',
                  name: 'Tahoma'
                },
                {
                  font: 'Times New Roman',
                  name: 'Times&nbsp;New&nbsp;Roman'
                },
                {
                  font: 'Verdana',
                  name: 'Verdana'
                }
              ],

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'FontSize',
            type : 'LinkToExistingButton'
          },

          {
            name : 'LineHeight',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'FontColors',

        Buttons :
        [
          {
            name : 'ForeColor',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Font color',
            command : 'openForeColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              foreColor : 'editorToolbarColorsTable',
              foreColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'BackColor',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Highlight',
            command : 'openBackColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              backColor : 'editorToolbarColorsTable',
              backColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },

      {
        name : 'FontColorsMini',
        sepSizeWidth : 24,

        Buttons :
        [
          {
            name : 'ForeColor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'BackColor',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'FontColorsMiniPoll',
        sepSizeWidth : 13,

        Buttons :
        [
          {
            name : 'ForeColor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'BackColor',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'FontColorsEmail',

        Buttons :
        [
          {
            name : 'ForeColorEmail',
            iconName : 'ForeColor',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Font color',
            command : 'openForeColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              foreColor : 'editorToolbarColorsTable',
              foreColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'BackColorEmail',
            iconName : 'BackColor',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Highlight',
            command : 'openBackColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              backColor : 'editorToolbarColorsTable',
              backColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },

      {
        name : 'FontColorsPublic',

        Buttons :
        [
          {
            name : 'ForeColor',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Font color',
            command : 'openForeColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              foreColor : 'editorToolbarColorsTable',
              foreColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'BackColor',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Highlight',
            command : 'openBackColorDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              backColor : 'editorToolbarColorsTable',
              backColorIds : 'editorToolbarColorsTable',
              themeColors: pConfig.themeStyles.colors,
              edgeAlign : 'center',
              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },

      {
        name : 'FontForeColorsPublic',

        Buttons :
        [
          {
            name : 'ForeColor',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BlockActions',

        Buttons :
        [
          {
            name : 'OL',
            title : 'Insert ordered list',
            command : 'insertOL'
          },

          {
            name : 'UL',
            title : 'Insert unordered list',
            command : 'insertUL'
          },

          {
            name : 'IndentBlock',
            title : 'Indent the block',
            command : 'indentBlock'
          },

          {
            name : 'OutdentBlock',
            title : 'Outdent the block',
            command : 'outdentBlock'
          }
        ]
      },

      {
        name : 'BlockActionsMiniPoll',
        sepSizeWidth : 13,

        Buttons :
        [
          {
            name : 'OL',
            type : 'LinkToExistingButton'
          },

          {
            name : 'UL',
            type : 'LinkToExistingButton'
          },

          {
            name : 'IndentBlock',
            type : 'LinkToExistingButton'
          },

          {
            name : 'OutdentBlock',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BlockActionsPublic',

        Buttons :
        [
          {
            name : 'OL',
            title : 'Insert ordered list',
            command : 'insertOL'
          },

          {
            name : 'UL',
            title : 'Insert unordered list',
            command : 'insertUL'
          },

          {
            name : 'IndentBlock',
            title : 'Indent the block',
            command : 'indentBlock'
          },

          {
            name : 'OutdentBlock',
            title : 'Outdent the block',
            command : 'outdentBlock'
          }
        ]
      },

      {
        name : 'TextAlign',

        Buttons :
        [
          {
            name : 'JustifyLeft',
            title : 'Justify left',
            command : 'justifyLeft'
          },

          {
            name : 'JustifyCenter',
            title : 'Justify center',
            command : 'justifyCenter'
          },

          {
            name : 'JustifyRight',
            title : 'Justify right',
            command : 'justifyRight'
          },

          {
            name : 'JustifyFull',
            title : 'Justify full',
            command : 'justifyFull'
          }
        ]
      },

      {
        name : 'TextAlignMini',
        sepSizeWidth : 24,

        Buttons :
        [
          {
            name : 'JustifyLeft',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyCenter',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyRight',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyFull',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'TextAlignMiniPoll',
        sepSizeWidth : 13,

        Buttons :
        [
          {
            name : 'JustifyLeft',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyCenter',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyRight',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyFull',
            type : 'LinkToExistingButton'
          }
        ]
      },


      {
        name : 'TextAlignPublic',

        Buttons :
        [
          {
            name : 'JustifyLeft',
            title : 'Justify left',
            command : 'justifyLeft'
          },

          {
            name : 'JustifyCenter',
            title : 'Justify center',
            command : 'justifyCenter'
          },

          {
            name : 'JustifyRight',
            title : 'Justify right',
            command : 'justifyRight'
          },

          {
            name : 'JustifyFull',
            title : 'Justify full',
            command : 'justifyFull'
          }
        ]
      },

      {
        name : 'TextAlignCardsPublic',

        Buttons :
        [
          {
            name : 'JustifyLeft',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyCenter',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyRight',
            type : 'LinkToExistingButton'
          },

          {
            name : 'JustifyFull',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'HTML',

        Buttons :
        [
          {
            name : 'InsertSnippet',
            type : 'DialogButton',
            title : 'Insert HTML snippet or script',
            command : 'openInsertSnippetDialog',

            parameters :
            {
              clipContainerId : 'idClipMainContainer',
              mainContainerId : 'idMainContainer',

              //directURL: '/Sys/Editor/InsertSnippetDlg/' + BEditor.environment.version,
              directURL: '/Common/Editor/Snippets/InsertSnippetDlg.aspx?' + BEditor.environment.version,
              top : null,
              left : null,
              width : 415,
              height : 295,
              minWidth : 300,
              minHeight : 215,
              isMoveable : true,
              isResizeable : true,
              isModal : true,
              isScrollable : false,

              callBackParameters :
              {
                htmlContent : ''
              }
            }
          },

          {
            name : 'HTMLEdit',
            type : 'DialogButton',
            title : WA && WA.AdminPanel && WA.AdminPanel.Resources && WA.AdminPanel.Resources.AdminToolBarEditor
                    && WA.AdminPanel.Resources.AdminToolBarEditor.HtmlEditor
                    && WA.AdminPanel.Resources.AdminToolBarEditor.HtmlEditor.DisabledJs === true
                    ? WA.AdminPanel.Resources.AdminToolBarEditor.HtmlEditor.DisabledJsTooltipText : 'Edit HTML',
            command : 'openEditHTMLDialog',

            parameters :
            {
              titleText: 'Edit HTML',
              top : null,
              left : null,
              width : 555,
              height : 382,
              minWidth : 500,
              minHeight : 215,
              isInitMaximize : true,
              marginMaximize : 17,
              isMoveable : true,
              isResizeable : true,
              isModal : true,
              isScrollable : false,
              isNotScrollable : true,

              callBackParameters :
              {
                htmlContent : ''
              }
            }
          }
        ]
      },

      {
        name : 'HTMLMini',
        sepSizeWidth : 24,

        Buttons :
        [
          {
            name : 'HTMLEdit',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'HTMLMiniPoll',
        sepSizeWidth : 14,

        Buttons :
        [
          {
            name : 'HTMLEdit',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BlockStylesPublic',

        Buttons :
        [
          {
            name : 'FormattingDropdownPublic',
            type : 'DropdownButton',
            title: 'Styles',
            command : 'openBlockFormattingDropdown',
            parameters :
            {
              directURL: '/Content/Editor/StylesDropdown.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              styles : pConfig.themeStyles.formatStyles,

              defaultStyleId : 'Normal',
              offsetY: -1,
              isTransparent : true,

              callBackParameters :
              {
                selectedStyleId : 'P'
              }
            }
          },

          {
            name : 'TextFontPublic',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Text font',
            command : 'openTextFontDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              textFonts : pConfig.themeStyles.fontStyles,

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'FontSize',
            type : 'DropdownButton',
            ddBtnFileURL: '/Admin/html_res/images/z.gif?' + BEditor.environment.version,
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Font size',
            command : 'openFontSizeDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              fontSizes :
              [
                '8',
                '9',
                '10',
                '11',
                '12',
                '14',
                '16',
                '18',
                '24',
                '30',
                '36',
                '48',
                '60',
                '72'
              ],

              fontSizeIds :
              [
                '8',
                '9',
                '10',
                '11',
                '12',
                '14',
                '16',
                '18',
                '24',
                '30',
                '36',
                '48',
                '60',
                '72'
              ],

              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },

      {
        name : 'BlockStylesCardsPublic',

        Buttons :
        [
          {
            name : 'TextFontPublic',
            type : 'LinkToExistingButton'
          },

          {
            name : 'FontSize',
            type : 'LinkToExistingButton'
          },

          {
            name: 'LineHeight',
            type: 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BlockStylesEventDescriptionPublic',

        Buttons :
          [
            {
              name : 'FormattingDropdownPublic',
              type : 'LinkToExistingButton'
            },

            {
              name : 'TextFontPublic',
              type : 'LinkToExistingButton'
            },

            {
              name : 'FontSize',
              type : 'LinkToExistingButton'
            },

            {
              name: 'LineHeight',
              type: 'LinkToExistingButton'
            }
          ]
      },

      {
        name : 'BlockStylesEmailLayoutLocal',

        Buttons :
        [
          {
            name : 'FormattingDropdownEmailLayoutLocal',
            iconName: 'FormattingDropdown',
            type : 'DropdownButton',
            title: 'Styles',
            command : 'openBlockFormattingDropdown',
            parameters :
            {
              directURL: '/Content/Editor/StylesDropdown.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              styles :
              [
                {
                  name: 'Normal',
                  tag: 'P',
                  cssClass: ''
                },
                {
                  name: 'Heading1',
                  tag: 'H1',
                  cssClass: ''
                },
                {
                  name: 'Heading2',
                  tag: 'H2',
                  cssClass: ''
                },
                {
                  name: 'Heading3',
                  tag: 'H3',
                  cssClass: ''
                },
                {
                  name: 'Heading4',
                  tag: 'H4',
                  cssClass: ''
                }
              ],

              defaultStyleId : 'Normal',
              offsetY: -1,
              isTransparent : true,

              callBackParameters :
              {
                selectedStyleId : 'P'
              }
            }
          },

          {
            name : 'TextFontEmailLayoutLocal',
            iconName: 'TextFontPublic',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Text font',
            command : 'openTextFontDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              textFonts :
              [
                {
                  font: 'Arial, Helvetica, sans-serif',
                  name: 'Arial'
                },
                {
                  font: 'Courier',
                  name: 'Courier'
                },
                {
                  font: 'Georgia',
                  name: 'Georgia'
                },
                {
                  font: 'Lucida Console',
                  name: 'Lucida&nbsp;Console'
                },
                {
                  font: 'Tahoma',
                  name: 'Tahoma'
                },
                {
                  font: 'Helvetica',
                  name: 'Helvetica'
                },
                {
                  font: 'Times New Roman',
                  name: 'Times&nbsp;New&nbsp;Roman'
                },
                {
                  font: 'Verdana',
                  name: 'Verdana'
                },
                {
                  font: 'Open Sans',
                  name: 'Open&nbsp;Sans'
                },
                {
                  font: 'Impact',
                  name: 'Impact'
                },
                {
                  font: 'Comic Sans',
                  name: 'Comic&nbsp;Sans'
                }
              ],

              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'FontSize',
            type : 'LinkToExistingButton'
          },

          {
            name: 'LineHeight',
            type: 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'InsertEmailLayoutLocal',

        Buttons : [
          {
            name : 'InsertLinkAndAnchorPublic',
            type : 'LinkToExistingButton'
          }
        ]
      },


      {
        name : 'InsertPublic',

        Buttons :
        [
          {
            name : 'InsertLinkAndAnchorPublic',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            ddBtnCurBgFileURL: '/Admin/html_res/images/editor-dd-textfont-curbg.gif?' + BEditor.environment.version,
            title : 'Insert or edit links and anchors',
            command : 'openLinkDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              excludeStrings : ['DocumentHandler.ashx?DocId=', 'Document.ashx?DocId=', '/Resources/'],

              buttons :
              [
                {
                  name : 'InsertLink',
                  type : 'DialogButton',
                  title : 'Insert or edit link',
                  command : 'openInsertLinkDialog',
                  separator : true,

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/ExternalLink/AddEditExternalLinkAdminDialog.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                    top : null,
                    left : null,
                    width : 525,
                    height : 190,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      title: '',
                      imageLink: '',
                      link: '',
                      tooltip: '',
                      openInNewWindow: true,
                      titleTooComplex: false
                    },

                    normalTitle : 'Insert link...',
                    currentTitle : 'Edit link...'
                  }
                },

                {
                  name : 'InsertAnchor',
                  type : 'DialogButton',
                  title : 'Insert anchor...',
                  command : 'openInsertAnchorDialog',

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/Anchors/AnchorDlgOuter.aspx?' + BEditor.environment.version,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 525,
                    height : 185,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      name: '',
                      title: '',
                      imageLink: '',
                      link: '',
                      tooltip: '',
                      titleTooComplex: false
                    },

                    normalTitle : 'Insert anchor...',
                    currentTitle : 'Edit anchor...'
                  }
                },

                {
                  name : 'LinkToAnchor',
                  type : 'DialogButton',
                  title : 'Insert link to anchor...',
                  command : 'openInsertLinkToAnchorDialog',
                  separator : true,
                  parameters :
                  {
                    normalTitle : 'Insert link to anchor...',
                    currentTitle : 'Edit link to anchor...'
                  }
                },

                {
                  name : 'AnchorsVisibility',
                  type : 'CommandButton',
                  title : 'Show/hide anchors',
                  command : 'setAnchorsVisibility',
                  parameters :
                  {
                    normalTitle : 'Show anchors',
                    currentTitle : 'Hide anchors'
                  }
                }
              ],

              edgeAlign : 'left',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'TablePublic',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Table',
            command : 'openTableDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              buttons :
              [
                {
                  name : 'CreateTable',
                  type : 'DialogButton',
                  title : 'Create table...',
                  command : 'openInsertTableDialog',
                  separator : true,

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/Tables/InsertTableDlgOuter.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 496, //755,
                    height: 475,
                    z: 37773,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      htmlContent : ''
                    }
                  }
                },

                {
                  name : 'TInsertMenu',
                  type : 'MenuButton',
                  title : 'Insert',
                  menuWidth : 155,

                  buttons :
                  [
                    {
                      name : 'TInsertRowBefore',
                      type : 'CommandButton',
                      title : 'Row above',
                      command : 'addTableRowBefore'
                    },

                    {
                      name : 'TInsertRowAfter',
                      type : 'CommandButton',
                      title : 'Row below',
                      command : 'addTableRowAfter',
                      separator : true
                    },

                    {
                      name : 'TInsertColumnBefore',
                      type : 'CommandButton',
                      title : 'Column to the left',
                      command : 'addTableColumnBefore'
                    },

                    {
                      name : 'TInsertColumnAfter',
                      type : 'CommandButton',
                      title : 'Column to the right',
                      command : 'addTableColumnAfter'
                    }
                  ]
                },

                {
                  name : 'TDeleteMenu',
                  type : 'MenuButton',
                  title : 'Delete',
                  menuWidth : 155,
                  separator : true,

                  buttons :
                  [
                    {
                      name : 'TDeleteTable',
                      type : 'CommandButton',
                      title : 'Delete table',
                      command : 'deleteTable'
                    },

                    {
                      name : 'TDeleteRow',
                      type : 'CommandButton',
                      title : 'Delete current row',
                      command : 'deleteTableRow'
                    },

                    {
                      name : 'TDeleteColumn',
                      type : 'CommandButton',
                      title : 'Delete current column',
                      command : 'deleteTableColumn'
                    }
                  ]
                },

                {
                  name : 'TSizeMenu',
                  type : 'MenuButton',
                  title : 'Size',
                  menuWidth : 120,

                  buttons :
                  [
                    {
                      name : 'TTableWidth',
                      type : 'SizeTableWidthDropdown',
                      title : 'Table width',
                      command : 'setTableSizeWidth'
                    },

                    {
                      name : 'TTableHeight',
                      type : 'SizeTableHeightDropdown',
                      title : 'Table height',
                      command : 'setTableSizeHeight',
                      separator : true
                    },

                    {
                      name : 'TRowHeight',
                      type : 'SizeHeightDropdown',
                      title : 'Row height',
                      command : 'setTableRowSizeHeight'
                    },

                    {
                      name : 'TColumnWidth',
                      type : 'SizeWidthDropdown',
                      title : 'Column width',
                      command : 'setTableColumnSizeWidth'
                    }
                  ]
                },

                {
                  name : 'TAlignMenu',
                  type : 'MenuButton',
                  title : 'Align',
                  menuWidth : 155,

                  buttons :
                  [
                    {
                      name : 'TTableAlignment',
                      type : 'TableAlignmentDropdown',
                      title : 'Table alignment',
                      command : 'setTableAlignment',
                      separator : true
                    },

                    {
                      name : 'TRowHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Row horizontal align',
                      command : 'setTableRowHorizontalAlign'
                    },

                    {
                      name : 'TRowVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Row vertical align',
                      command : 'setTableRowVerticalAlign',
                      separator : true
                    },

                    {
                      name : 'TColumnHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Column horizontal align',
                      command : 'setTableColumnHorizontalAlign'
                    },

                    {
                      name : 'TColumnVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Column vertical align',
                      command : 'setTableColumnVerticalAlign',
                      separator : true
                    },

                    {
                      name : 'TCellHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Cell horizontal align',
                      command : 'setTableCellHorizontalAlign'
                    },

                    {
                      name : 'TCellVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Cell vertical align',
                      command : 'setTableCellVerticalAlign'
                    }
                  ]
                },

                {
                  name : 'TCellsPaddingMenu',
                  type : 'CellsPaddingDropdown',
                  title : 'Padding',
                  command : 'setTableCellsPadding',
                  separator : true
                },

                {
                  name : 'ShowHideTablesBorders',
                  type : 'CommandButton',
                  title : 'Outline tables',
                  normalTitle : 'Hide outline tables',
                  currentTitle : 'Show outline tables',
                  command : 'showHideTablesBorders'
                },

                {
                  name : 'TBorderMenu',
                  type : 'MenuButton',
                  title : 'Border',
                  menuWidth : 155,

                  buttons :
                  [
                    {
                      name : 'TTableBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Table border width',
                      command : 'setTableBorderWidth'
                    },

                    {
                      name : 'TTableBorderColor',
                      type : 'CommandButton',
                      title : 'Table border color',
                      command : 'setTableBorderColor',
                      separator : true
                    },

                    {
                      name : 'TRowBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Row border width',
                      command : 'setTableRowBorderWidth'
                    },

                    {
                      name : 'TRowBorderColor',
                      type : 'CommandButton',
                      title : 'Row border color',
                      command : 'setTableRowBorderColor',
                      separator : true
                    },

                    {
                      name : 'TColumnBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Column border width',
                      command : 'setTableColumnBorderWidth'
                    },

                    {
                      name : 'TColumnBorderColor',
                      type : 'CommandButton',
                      title : 'Column border color',
                      command : 'setTableColumnBorderColor',
                      separator : true
                    },

                    {
                      name : 'TCellBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Cell border width',
                      command : 'setTableCellBorderWidth'
                    },

                    {
                      name : 'TCellBorderColor',
                      type : 'CommandButton',
                      title : 'Cell border color',
                      command : 'setTableCellBorderColor',
                      separator : true
                    },

                    {
                      name : 'TAllCellsBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'All cells border width',
                      command : 'setTableAllCellsBorderWidth'
                    },

                    {
                      name : 'TAllCellsBorderColor',
                      type : 'CommandButton',
                      title : 'All cells border color',
                      command : 'setTableAllCellsBorderColor'
                    }
                  ]
                },

                {
                  name : 'TBackgroundMenu',
                  type : 'MenuButton',
                  title : 'Background',
                  menuWidth : 175,

                  buttons :
                  [
                    {
                      name : 'TRowBackgroundColor',
                      type : 'CommandButton',
                      title : 'Row background color',
                      command : 'setTableRowBackgroundColor'
                    },

                    {
                      name : 'TColumnBackgroundColor',
                      type : 'CommandButton',
                      title : 'Column background color',
                      command : 'setTableColumnBackgroundColor'
                    },

                    {
                      name : 'TCellBackgroundColor',
                      type : 'CommandButton',
                      title : 'Cell background color',
                      command : 'setTableCellBackgroundColor'
                    },

                    {
                      name : 'TAllCellsBackgroundColor',
                      type : 'CommandButton',
                      title : 'All cells background color',
                      command : 'setTableAllCellsBackgroundColor'
                    }
                  ]
                }
              ],

              edgeAlign : 'left',
              offsetY: -1,
              isTransparent : true
            }
          }
        ]
      },

      {
        name : 'MorePublicActions',

        Buttons :
        [
          {
            iconName: 'MoreButton',
            name : 'MorePublicDropdown',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'More...',
            command : 'openMoreLocalDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              edgeAlign: 'right',

              buttons :
              [
                {
                  name : 'Copy',
                  title : 'Copy',
                  command : 'copy'
                },

                {
                  name : 'Paste',
                  title : 'Paste',
                  command : 'paste'
                },

                {
                  name : 'CopyStyle',
                  title : 'Format painter',
                  command : 'copyStyle'
                },

                {
                  name : 'ClearFormatting',
                  title : 'Clear formatting',
                  command : 'cleanupHTML'
                }
              ]
            }
          }
        ]
      },

      {
        name : 'MoreLocalActions',

        Buttons :
        [
          {
            iconName: 'MoreButton',
            name : 'MoreLocalDropdown',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'More...',
            command : 'openMoreLocalDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              edgeAlign: 'right',

              buttons :
              [
                {
                  name : 'CopyLocal',
                  title : 'Copy',
                  command : 'copy'
                },

                {
                  name : 'PasteLocal',
                  title : 'Paste',
                  command : 'paste'
                },

                {
                  name : 'CopyStyleLocal',
                  title : 'Format painter',
                  command : 'copyStyle'
                },

                {
                  name : 'ClearFormattingLocal',
                  title : 'Clear formatting',
                  command : 'cleanupHTML',
                  separator : true
                },

                {
                  name : 'InsertDocumentLocal',
                  type : 'DialogButton',
                  title : 'Insert file',
                  command : 'openInsertDocumentDialog',
                  model : pConfig.resources.insertResourceModuleResources,
                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    includeStrings : ['DocumentHandler.ashx?DocId=', 'Document.ashx?DocId=', '/Resources/'],

                    directURL: '/Common/Editor/Document/DocumentDlgOuter.aspx?' + BEditor.environment.version,
                    reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+document&f=Documents&cs=width:643px;height:400px&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 650,
                    height : BEditor.device.isIOS ? 639 : 616,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,
                    isCustomFixWinHeight : true,

                    callBackParameters :
                    {
                      link: '',
                      title: '',
                      imageLink: '',
                      tooltip: '',
                      titleTooComplex: false
                    }
                  }
                },

                {
                  name : 'InsertPictureLocal',
                  type : 'DialogButton',
                  title : 'Insert image',
                  command : 'openInsertImageDialog',
                  model : pConfig.resources.insertResourceModuleResources,
                  parameters:
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',
                    reloadURLTemplate: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f={0}&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                    directURL: '/Content/Images/PictureDlgOuter.aspx?' + BEditor.environment.version,
                    reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f=Pictures&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 650,
                    height : BEditor.device.isIOS ? 750 : 700,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,
                    isCustomFixWinHeight : true,

                    callBackParameters :
                    {
                      src : '',
                      title : '',
                      width : 100,
                      height : 100,
                      border : 0,
                      align : null,
                      marginTop : 7,
                      marginBottom : 7,
                      marginLeft : 7,
                      marginRight : 7
                    }
                  }
                },

                {
                  name : 'InsertHRLocal',
                  type : 'DialogButton',
                  title : 'Insert divider',
                  command : 'insertHR',

                  parameters:
                  {
                    titleText: 'Insert divider',
                    top: null,
                    left: null,
                    width: 360,
                    height: 402,
                    minWidth: 360,
                    minHeight: 402,
                    marginMaximize: 17,
                    isMoveable: true,
                    isModal: true,
                    isScrollable: false,
                    isResizeable: false,

                    callBackParameters:
                    {
                      cssClass: '',
                      inlineStyle: ''
                    }
                  }
                },

                {
                  name : 'InsertArtTextLocal',
                  type : 'DialogButton',
                  title : 'Art text',
                  command : 'openInsertArtTextDialog',
                  separator : true,
                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/ArtText/ArtTextDialog.aspx?frameMode=0&ver=' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 675,
                    height : 650,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable: false,
                    z: 37773,

                    callBackParameters :
                    {
                      src : '',
                      title : '',
                      width : 100,
                      height : 100,
                      border : 0,
                      align : null,
                      marginTop : 7,
                      marginBottom : 7,
                      marginLeft : 7,
                      marginRight : 7
                    }
                  }
                },

                {
                  name : 'InsertSnippetLocal',
                  type : 'DialogButton',
                  title : 'Insert snippet',
                  command : 'openInsertSnippetDialog',

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/Snippets/InsertSnippetDlg.aspx?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 415,
                    height : 295,
                    minWidth : 300,
                    minHeight : 215,
                    isMoveable : true,
                    isResizeable : true,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      htmlContent : ''
                    }
                  }
                },

                {
                  name : 'HTMLEditLocal',
                  type : 'DialogButton',
                  title : 'Edit HTML',
                  command : 'openEditHTMLDialog',

                  parameters :
                  {
                    titleText: 'Edit HTML',
                    top : null,
                    left : null,
                    width : 555,
                    height : 382,
                    minWidth : 500,
                    minHeight : 215,
                    isInitMaximize : true,
                    marginMaximize : 17,
                    isMoveable : true,
                    isResizeable : true,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      htmlContent : ''
                    }
                  }
                }
              ]
            }
          }
        ]
      },

      {
        name : 'MoreEventDescriptionLocalActions',

        Buttons :
          [
            {
              iconName: 'MoreButton',
              name : 'MoreLocalDropdown',
              type : 'DropdownButton',
              ddBtnFileURL : '/Admin/html_res/images/z.gif',
              ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
              title : 'More...',
              command : 'openMoreLocalDropdown',

              parameters :
                {
                  directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                  edgeAlign: 'right',

                  buttons :
                    [
                      {
                        name : 'CopyLocal',
                        title : 'Copy',
                        command : 'copy'
                      },

                      {
                        name : 'PasteLocal',
                        title : 'Paste',
                        command : 'paste'
                      },

                      {
                        name : 'CopyStyleLocal',
                        title : 'Format painter',
                        command : 'copyStyle'
                      },

                      {
                        name : 'ClearFormattingLocal',
                        title : 'Clear formatting',
                        command : 'cleanupHTML',
                        separator : true
                      },

                      {
                        name : 'InsertDocumentLocal',
                        type : 'DialogButton',
                        title : 'Insert file',
                        command : 'openInsertDocumentDialog',
                        model : pConfig.resources.insertResourceModuleResources,
                        parameters :
                          {
                            clipContainerId : 'idClipMainContainer',
                            mainContainerId : 'idMainContainer',

                            includeStrings : ['DocumentHandler.ashx?DocId=', 'Document.ashx?DocId=', '/Resources/'],

                            directURL: '/Common/Editor/Document/DocumentDlgOuter.aspx?' + BEditor.environment.version,
                            reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+document&f=Documents&cs=width:643px;height:400px&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                            waitMessage : 'Please wait...',
                            waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                            top : null,
                            left : null,
                            width : 650,
                            height : BEditor.device.isIOS ? 639 : 616,
                            isMoveable : true,
                            isResizeable : false,
                            isModal : true,
                            isScrollable : false,
                            isCustomFixWinHeight : true,

                            callBackParameters :
                              {
                                link: '',
                                title: '',
                                imageLink: '',
                                tooltip: '',
                                titleTooComplex: false
                              }
                          }
                      },

                      {
                        name : 'InsertPictureLocal',
                        type : 'DialogButton',
                        title : 'Insert image',
                        command : 'openInsertImageDialog',
                        model : pConfig.resources.insertResourceModuleResources,
                        parameters:
                          {
                            clipContainerId : 'idClipMainContainer',
                            mainContainerId : 'idMainContainer',
                            reloadURLTemplate: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f={0}&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                            directURL: '/Content/Images/PictureDlgOuter.aspx?' + BEditor.environment.version,
                            reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f=Pictures&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
                            waitMessage : 'Please wait...',
                            waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                            top : null,
                            left : null,
                            width : 650,
                            height : BEditor.device.isIOS ? 750 : 700,
                            isMoveable : true,
                            isResizeable : false,
                            isModal : true,
                            isScrollable : false,
                            isCustomFixWinHeight : true,

                            callBackParameters :
                              {
                                src : '',
                                title : '',
                                width : 100,
                                height : 100,
                                border : 0,
                                align : null,
                                marginTop : 7,
                                marginBottom : 7,
                                marginLeft : 7,
                                marginRight : 7
                              }
                          }
                      },

                      {
                        name : 'InsertHRLocal',
                        type : 'DialogButton',
                        title : 'Insert divider',
                        command : 'insertHR',

                        parameters:
                          {
                            titleText: 'Insert divider',
                            top: null,
                            left: null,
                            width: 360,
                            height: 402,
                            minWidth: 360,
                            minHeight: 402,
                            marginMaximize: 17,
                            isMoveable: true,
                            isModal: true,
                            isScrollable: false,
                            isResizeable: false,

                            callBackParameters:
                              {
                                cssClass: '',
                                inlineStyle: ''
                              }
                          }
                      },

                      {
                        name : 'InsertArtTextLocal',
                        type : 'DialogButton',
                        title : 'Art text',
                        command : 'openInsertArtTextDialog',
                        parameters :
                          {
                            clipContainerId : 'idClipMainContainer',
                            mainContainerId : 'idMainContainer',

                            directURL: '/Common/Editor/ArtText/ArtTextDialog.aspx?frameMode=0&ver=' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                            waitMessage : 'Please wait...',
                            waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                            top : null,
                            left : null,
                            width : 675,
                            height : 650,
                            isMoveable : true,
                            isResizeable : false,
                            isModal : true,
                            isScrollable: false,
                            z: 37773,

                            callBackParameters :
                              {
                                src : '',
                                title : '',
                                width : 100,
                                height : 100,
                                border : 0,
                                align : null,
                                marginTop : 7,
                                marginBottom : 7,
                                marginLeft : 7,
                                marginRight : 7
                              }
                          }
                      }
                    ]
                }
            }
          ]
      },

      {
        name : 'MoreEmailLayoutLocalActions',

        Buttons :
        [
          {
            iconName: 'MoreButton',
            name : 'MoreLocalDropdown',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'More...',
            command : 'openMoreLocalDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              edgeAlign: 'right',

              buttons :
              [
                {
                  name : 'CopyLocal',
                  title : 'Copy',
                  command : 'copy'
                },

                {
                  name : 'PasteLocal',
                  title : 'Paste',
                  command : 'paste'
                },

                {
                  name : 'CopyStyleLocal',
                  title : 'Format painter',
                  command : 'copyStyle'
                },

                {
                  name : 'ClearFormattingLocal',
                  title : 'Clear formatting',
                  command : 'cleanupHTML'
                }
              ]
            }
          }
        ]
      },

      {
        name : 'BigSizeButtonsEmailLayoutLocal',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 1,
        sepSizeHeight : 80,

        Buttons :
          [
            {
              name : 'EmailMacrosDialog',
              type : 'LinkToExistingButton'
            },

            {
              name : 'InsertDocument',
              type : 'LinkToExistingButton'
            }
          ]
      },
//==============================================================================================================================
      {
        name : 'BigSizeButtons',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 16,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'DialogButton',
            title : 'Insert picture',
            command : 'openInsertImageDialog',
            model : pConfig.resources.insertResourceModuleResources,
            parameters :
            {
              clipContainerId : 'idClipMainContainer',
              mainContainerId : 'idMainContainer',
              reloadURLTemplate: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f={0}&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
              directURL: '/Content/Images/PictureDlgOuter.aspx?' + BEditor.environment.version,
              reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+picture&f=Pictures&cs=width:643px;height:400px&fc=parent.onSelectedFolderChanged&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
              waitMessage : 'Please wait...',
              waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
              top : null,
              left : null,
              width : 650,
              height : BEditor.device.isIOS ? 750 : 700,
              isMoveable : true,
              isResizeable : false,
              isModal : true,
              isScrollable : false,
              isCustomFixWinHeight : true,

              callBackParameters :
              {
                src : '',
                title : '',
                width : 100,
                height : 100,
                border : 0,
                align : null,
                marginTop : 7,
                marginBottom : 7,
                marginLeft : 7,
                marginRight : 7
              }
            }
          },

          {
            name : 'InsertDocument',
            type : 'DialogButton',
            title : 'Insert file or edit file properties',
            command : 'openInsertDocumentDialog',
            model : pConfig.resources.insertResourceModuleResources,
            parameters :
            {
              clipContainerId : 'idClipMainContainer',
              mainContainerId : 'idMainContainer',

              includeStrings : ['DocumentHandler.ashx?DocId=', 'Document.ashx?DocId=', '/Resources/'],

              directURL: '/Common/Editor/Document/DocumentDlgOuter.aspx?' + BEditor.environment.version,
              reloadURL: '/Common/WebDavBrowser/AjaxBrowser.aspx?ht=Insert+document&f=Documents&cs=width:643px;height:400px&ic=parent.onSelectedItemsChanged&bl=parent.onAjaxBrowserInitiated&sb=true&' + BEditor.environment.version,
              waitMessage : 'Please wait...',
              waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
              top : null,
              left : null,
              width : 650,
              height : BEditor.device.isIOS ? 639 : 616,
              isMoveable : true,
              isResizeable : false,
              isModal : true,
              isScrollable : false,
              isCustomFixWinHeight : true,

              callBackParameters :
              {
                link: '',
                title: '',
                imageLink: '',
                tooltip: '',
                titleTooComplex: false
              }
            }
          },

          {
            name : 'InsertLinkAndAnchor',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            ddBtnCurBgFileURL: '/Admin/html_res/images/editor-dd-textfont-curbg.gif?' + BEditor.environment.version,
            title : 'Insert or edit links and anchors',
            command : 'openLinkDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              excludeStrings : ['DocumentHandler.ashx?DocId=', 'Document.ashx?DocId=', '/Resources/'],

              buttons :
              [
                {
                  name : 'InsertLink',
                  type : 'DialogButton',
                  title : 'Insert or edit link',
                  command : 'openInsertLinkDialog',
                  separator : true,

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/ExternalLink/AddEditExternalLinkAdminDialog.aspx?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
                    top : null,
                    left : null,
                    width : 525,
                    height : 190,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      title: '',
                      imageLink: '',
                      link: '',
                      tooltip: '',
                      openInNewWindow: true,
                      titleTooComplex: false
                    },

                    normalTitle : 'Insert link...',
                    currentTitle : 'Edit link...'
                  }
                },

                {
                  name : 'InsertAnchor',
                  type : 'DialogButton',
                  title : 'Insert anchor...',
                  command : 'openInsertAnchorDialog',

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/Anchors/AnchorDlgOuter.aspx?' + BEditor.environment.version,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 525,
                    height : 185,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      name: '',
                      title: '',
                      imageLink: '',
                      link: '',
                      tooltip: '',
                      titleTooComplex: false
                    },

                    normalTitle : 'Insert anchor...',
                    currentTitle : 'Edit anchor...'
                  }
                },

                {
                  name : 'LinkToAnchor',
                  type : 'DialogButton',
                  title : 'Insert link to anchor...',
                  command : 'openInsertLinkToAnchorDialog',
                  separator : true,
                  parameters :
                  {
                    normalTitle : 'Insert link to anchor...',
                    currentTitle : 'Edit link to anchor...'
                  }
                },

                {
                  name : 'AnchorsVisibility',
                  type : 'CommandButton',
                  title : 'Show/hide anchors',
                  command : 'setAnchorsVisibility',
                  parameters :
                  {
                    normalTitle : 'Show anchors',
                    currentTitle : 'Hide anchors'
                  }
                }
              ],

              edgeAlign : 'left',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'Table',
            type : 'DropdownButton',
            ddBtnFileURL : '/Admin/html_res/images/z.gif',
            ddBtnBgFileURL: '/Admin/html_res/images/editor-dd-textfont-bg.gif?' + BEditor.environment.version,
            title : 'Table',
            command : 'openTableDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              buttons :
              [
                {
                  name : 'CreateTable',
                  type : 'DialogButton',
                  title : 'Create table...',
                  command : 'openInsertTableDialog',
                  separator : true,

                  parameters :
                  {
                    clipContainerId : 'idClipMainContainer',
                    mainContainerId : 'idMainContainer',

                    directURL: '/Common/Editor/Tables/InsertTableDlgOuter.aspx?' + BEditor.environment.version,
                    waitMessage : 'Please wait...',
                    waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
                    top : null,
                    left : null,
                    width : 496, //755,
                    height: 475,
                    z: 37773,
                    isMoveable : true,
                    isResizeable : false,
                    isModal : true,
                    isScrollable : false,

                    callBackParameters :
                    {
                      htmlContent : ''
                    }
                  }
                },

                {
                  name : 'TInsertMenu',
                  type : 'MenuButton',
                  title : 'Insert',
                  menuWidth : 150,

                  buttons :
                  [
                    {
                      name : 'TInsertRowBefore',
                      type : 'CommandButton',
                      title : 'Row above',
                      command : 'addTableRowBefore'
                    },

                    {
                      name : 'TInsertRowAfter',
                      type : 'CommandButton',
                      title : 'Row below',
                      command : 'addTableRowAfter',
                      separator : true
                    },

                    {
                      name : 'TInsertColumnBefore',
                      type : 'CommandButton',
                      title : 'Column to the left',
                      command : 'addTableColumnBefore'
                    },

                    {
                      name : 'TInsertColumnAfter',
                      type : 'CommandButton',
                      title : 'Column to the right',
                      command : 'addTableColumnAfter'
                    }
                  ]
                },

                {
                  name : 'TDeleteMenu',
                  type : 'MenuButton',
                  title : 'Delete',
                  menuWidth : 165,
                  separator : true,

                  buttons :
                  [
                    {
                      name : 'TDeleteRow',
                      type : 'CommandButton',
                      title : 'Delete current row',
                      command : 'deleteTableRow'
                    },

                    {
                      name : 'TDeleteColumn',
                      type : 'CommandButton',
                      title : 'Delete current column',
                      command : 'deleteTableColumn'
                    }
                  ]
                },

                {
                  name : 'TSizeMenu',
                  type : 'MenuButton',
                  title : 'Size',
                  menuWidth : 120,

                  buttons :
                  [
                    {
                      name : 'TTableWidth',
                      type : 'SizeTableWidthDropdown',
                      title : 'Table width',
                      command : 'setTableSizeWidth'
                    },

                    {
                      name : 'TTableHeight',
                      type : 'SizeTableHeightDropdown',
                      title : 'Table height',
                      command : 'setTableSizeHeight',
                      separator : true
                    },

                    {
                      name : 'TRowHeight',
                      type : 'SizeHeightDropdown',
                      title : 'Row height',
                      command : 'setTableRowSizeHeight'
                    },

                    {
                      name : 'TColumnWidth',
                      type : 'SizeWidthDropdown',
                      title : 'Column width',
                      command : 'setTableColumnSizeWidth'
                    }
                  ]
                },

                {
                  name : 'TAlignMenu',
                  type : 'MenuButton',
                  title : 'Align',
                  menuWidth : 180,

                  buttons :
                  [
                    {
                      name : 'TTableAlignment',
                      type : 'TableAlignmentDropdown',
                      title : 'Table alignment',
                      command : 'setTableAlignment',
                      separator : true
                    },

                    {
                      name : 'TRowHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Row horizontal align',
                      command : 'setTableRowHorizontalAlign'
                    },

                    {
                      name : 'TRowVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Row vertical align',
                      command : 'setTableRowVerticalAlign',
                      separator : true
                    },

                    {
                      name : 'TColumnHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Column horizontal align',
                      command : 'setTableColumnHorizontalAlign'
                    },

                    {
                      name : 'TColumnVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Column vertical align',
                      command : 'setTableColumnVerticalAlign',
                      separator : true
                    },

                    {
                      name : 'TCellHorizontalAlign',
                      type : 'HorizontalAlignDropdown',
                      title : 'Cell horizontal align',
                      command : 'setTableCellHorizontalAlign'
                    },

                    {
                      name : 'TCellVerticalAlign',
                      type : 'VerticalAlignDropdown',
                      title : 'Cell vertical align',
                      command : 'setTableCellVerticalAlign'
                    }
                  ]
                },

                {
                  name : 'TCellsPaddingMenu',
                  type : 'CommandButton',
                  title : 'Padding',
                  command : 'setTableCellsPadding',
                  separator : true
                },

                {
                  name : 'ShowHideTablesBorders',
                  type : 'CommandButton',
                  title : 'Outline tables',
                  normalTitle : 'Hide outline tables',
                  currentTitle : 'Show outline tables',
                  command : 'showHideTablesBorders'
                },

                {
                  name : 'TBorderMenu',
                  type : 'MenuButton',
                  title : 'Border',
                  menuWidth : 165,

                  buttons :
                  [
                    {
                      name : 'TTableBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Table border width',
                      command : 'setTableBorderWidth'
                    },

                    {
                      name : 'TTableBorderColor',
                      type : 'CommandButton',
                      title : 'Table border color',
                      command : 'setTableBorderColor',
                      separator : true
                    },

                    {
                      name : 'TRowBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Row border width',
                      command : 'setTableRowBorderWidth'
                    },

                    {
                      name : 'TRowBorderColor',
                      type : 'CommandButton',
                      title : 'Row border color',
                      command : 'setTableRowBorderColor',
                      separator : true
                    },

                    {
                      name : 'TColumnBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Column border width',
                      command : 'setTableColumnBorderWidth'
                    },

                    {
                      name : 'TColumnBorderColor',
                      type : 'CommandButton',
                      title : 'Column border color',
                      command : 'setTableColumnBorderColor',
                      separator : true
                    },

                    {
                      name : 'TCellBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'Cell border width',
                      command : 'setTableCellBorderWidth'
                    },

                    {
                      name : 'TCellBorderColor',
                      type : 'CommandButton',
                      title : 'Cell border color',
                      command : 'setTableCellBorderColor',
                      separator : true
                    },

                    {
                      name : 'TAllCellsBorderWidth',
                      type : 'BorderWidthDropdown',
                      title : 'All cells border width',
                      command : 'setTableAllCellsBorderWidth'
                    },

                    {
                      name : 'TAllCellsBorderColor',
                      type : 'CommandButton',
                      title : 'All cells border color',
                      command : 'setTableAllCellsBorderColor'
                    }
                  ]
                },

                {
                  name : 'TBackgroundMenu',
                  type : 'MenuButton',
                  title : 'Background',
                  menuWidth : 190,

                  buttons :
                  [
                    {
                      name : 'TRowBackgroundColor',
                      type : 'CommandButton',
                      title : 'Row background color',
                      command : 'setTableRowBackgroundColor'
                    },

                    {
                      name : 'TColumnBackgroundColor',
                      type : 'CommandButton',
                      title : 'Column background color',
                      command : 'setTableColumnBackgroundColor'
                    },

                    {
                      name : 'TCellBackgroundColor',
                      type : 'CommandButton',
                      title : 'Cell background color',
                      command : 'setTableCellBackgroundColor'
                    },

                    {
                      name : 'TAllCellsBackgroundColor',
                      type : 'CommandButton',
                      title : 'All cells background color',
                      command : 'setTableAllCellsBackgroundColor'
                    }
                  ],

                  separator : true
                },

                {
                  name : 'DeleteTable',
                  type : 'CommandButton',
                  title : 'Delete table',
                  command : 'deleteTable'
                }
              ],

              edgeAlign : 'left',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'Layer',
            type : 'DropdownButton',
            ddBtnFileURL : BEditor.environment.adminResImgPath + 'editor-icons.png?' + BEditor.environment.version,
            title : 'Position: absolute',
            command : 'openLayerDropdown',

            parameters :
            {
              directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,

              buttons :
              [
                {
                  name : 'CreateDeleteLayer',
                  type : 'CommandButton',
                  title : 'Create new layer',
                  command : 'setPositionAbsolute',
                  separator : true,

                  parameters :
                  {
                    normalTitle : 'Create new layer',
                    currentTitle : 'Delete layer'
                  }
                },

                {
                  name : 'BringForwardLayer',
                  type : 'CommandButton',
                  title : 'Bring forward',
                  iconOffset : 0,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'setZIndexForward',

                  parameters :
                  {
                    normalTitle : 'Bring forward',
                    currentTitle : 'Bring forward'
                  }
                },

                {
                  name : 'SendBackwardLayer',
                  type : 'CommandButton',
                  title : 'Send backward',
                  iconOffset : 16,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'setZIndexBack',
                  separator : true,

                  parameters :
                  {
                    normalTitle : 'Send backward',
                    currentTitle : 'Send backward'
                  }
                },

                {
                  name : 'HorizontalAlignLeftLayer',
                  type : 'CommandButton',
                  title : 'Horizontal align left',
                  iconOffset : 32,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'horizontalAlignLeftLayer',

                  parameters :
                  {
                    normalTitle : 'Horizontal align left',
                    currentTitle : 'Horizontal align left'
                  }
                },

                {
                  name : 'HorizontalAlignCenterLayer',
                  type : 'CommandButton',
                  title : 'Horizontal align center',
                  iconOffset : 48,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'horizontalAlignCenterLayer',

                  parameters :
                  {
                    normalTitle : 'Horizontal align center',
                    currentTitle : 'Horizontal align center'
                  }
                },

                {
                  name : 'HorizontalAlignRightLayer',
                  type : 'CommandButton',
                  title : 'Horizontal align right',
                  iconOffset : 64,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'horizontalAlignRightLayer',
                  separator : true,

                  parameters :
                  {
                    normalTitle : 'Horizontal align right',
                    currentTitle : 'Horizontal align right'
                  }
                },

                {
                  name : 'VerticalAlignTopLayer',
                  type : 'CommandButton',
                  title : 'Vertical align top',
                  iconOffset : 80,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'verticalAlignTopLayer',

                  parameters :
                  {
                    normalTitle : 'Vertical align top',
                    currentTitle : 'Vertical align top'
                  }
                },

                {
                  name : 'VerticalAlignMiddleLayer',
                  type : 'CommandButton',
                  title : 'Vertical align middle',
                  iconOffset : 96,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'verticalAlignMiddleLayer',

                  parameters :
                  {
                    normalTitle : 'Vertical align middle',
                    currentTitle : 'Vertical align middle'
                  }
                },

                {
                  name : 'VerticalAlignBottomLayer',
                  type : 'CommandButton',
                  title : 'Vertical align bottom',
                  iconOffset : 112,
                  iconWidth : 16,
                  iconHeight : 11,
                  command : 'verticalAlignBottomLayer',

                  parameters :
                  {
                    normalTitle : 'Vertical align bottom',
                    currentTitle : 'Vertical align bottom'
                  }
                }
              ],

              edgeAlign : 'left',
              offsetY: -1,
              isTransparent : true
            }
          },

          {
            name : 'InsertArtText',
            type : 'DialogButton',
            title : 'Insert or edit art text',
            command : 'openInsertArtTextDialog',
            parameters :
            {
              clipContainerId : 'idClipMainContainer',
              mainContainerId : 'idMainContainer',

              directURL: '/Common/Editor/ArtText/ArtTextDialog.aspx?frameMode=0&ver=' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
              waitMessage : 'Please wait...',
              waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
              top : null,
              left : null,
              width : 675,
              height : 650,
              isMoveable : true,
              isResizeable : false,
              isModal : true,
              isScrollable: false,
              z: 37773,

              callBackParameters :
              {
                src : '',
                title : '',
                width : 100,
                height : 100,
                border : 0,
                align : null,
                marginTop : 7,
                marginBottom : 7,
                marginLeft : 7,
                marginRight : 7
              }
            }
          },

          {
            name : 'InsertHR',
            type : 'DialogButton',
            title : 'Insert horizontal rule',
            command : 'insertHR',

            parameters:
            {
              titleText: 'Insert divider',
              top: null,
              left: null,
              width: 360,
              height: 402,
              minWidth: 360,
              minHeight: 402,
              marginMaximize: 17,
              isMoveable: true,
              isModal: true,
              isScrollable: false,
              isResizeable: false,

              callBackParameters:
              {
                cssClass: '',
                inlineStyle: ''
              }
            }
          }
        ]
      },

      {
        name : 'BigSizeButtonsMiddle',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 16,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertDocument',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertLinkAndAnchor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Table',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BigSizeButtonsMini',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 16,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertLinkAndAnchor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertArtText',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertHR',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BigSizeButtonsCards',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 1,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'LinkToExistingButton'
          },

          {
            name : 'EmailMacrosDialog',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BigSizeButtonsEvent',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 16,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertDocument',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertLinkAndAnchor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Table',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertArtText',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertHR',
            type : 'LinkToExistingButton'
          }
        ]
      },

      {
        name : 'BigSizeButtonsEmail',
        btnFileName: 'iconsBig',
        btnOverlapping: 1,
        doubleSize : true,
        sepFileURL: '/Admin/html_res/images/editor-sep.gif?' + BEditor.environment.version,
        sepSizeWidth : 16,
        sepSizeHeight : 80,

        Buttons :
        [
          {
            name : 'InsertPicture',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertDocument',
            type : 'LinkToExistingButton'
          },

          {
            name : 'InsertLinkAndAnchor',
            type : 'LinkToExistingButton'
          },

          {
            name : 'Table',
            type : 'LinkToExistingButton'
          },

          {
            name: 'EmailMacrosDialog',
            type: 'DialogButton',
            title: 'Insert macro',
            command: 'openInsertEmailMacrosDialog',

            parameters :
            {
              clipContainerId : 'idClipMainContainer',
              mainContainerId : 'idMainContainer',

              directURL: '/Common/Editor/Macros/EmailCustomizationMacros.aspx?' + BEditor.environment.version,
              waitMessage : 'Please wait...',
              waitMessageImgURL: '/Admin/html_res/images/async-load-progress-01.gif?' + BEditor.environment.version,
              top : null,
              left : null,
              width: (BEditor.browser.isIE) ? 581 : 577,
              height : 577,
              isMoveable : true,
              isResizeable : false,
              isModal : true,
              isScrollable : false,
              isCustomFixWinHeight : true,

              callBackParameters :
              {
                macrosJson: null,
                macros: ''
              }
            }
          }
        ]
      }
    ]
  });
}